module.exports = __webpack_public_path__ + "img/store-active.b5b9b08c.svg";